import PartnerAPIKeyTypes from 'store/actionTypes/partnerAPIKey'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  current: {},
  pagination: {},
  filter: {},
  log: {
    list: [],
    pagination: {},
    filter: {}
  }
}

const partnerAPIKey = (state = initialData, action = {}) => {
  const { payload } = action
  switch (action.type) {
    case PartnerAPIKeyTypes.GET_PARTNER_API_KEYS_SUCCESS:
      return {
        ...state,
        list: payload?.items || [],
        pagination: payload?.meta || {}
      }
    case PartnerAPIKeyTypes.GET_PARTNER_API_KEY_DETAIL_SUCCESS:
      return {
        ...state,
        current: payload?.companyAPIKey || {}
      }
    case PartnerAPIKeyTypes.GET_LOGS_PARTNER_API_KEY_SUCCESS:
      return {
        ...state,
        log: {
          ...state.log,
          list: payload?.items || [],
          pagination: payload?.meta || {}
        }
      }
    case PartnerAPIKeyTypes.UPDATE_FILTER_PARTNER_API_KEY_SUCCESS:
      return {
        ...state,
        filter: payload
      }
    case PartnerAPIKeyTypes.UPDATE_FILTER_LOG_API_KEY_SUCCESS:
      return {
        ...state,
        log: {
          ...state.log,
          filter: payload
        }
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData
    default:
      return state
  }
}

export default partnerAPIKey
